var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52729 5.52876C3.78764 5.26841 4.20975 5.26841 4.4701 5.52876L7.9987 9.05735L11.5273 5.52876C11.7876 5.26841 12.2098 5.26841 12.4701 5.52876C12.7305 5.78911 12.7305 6.21122 12.4701 6.47157L8.4701 10.4716C8.20975 10.7319 7.78764 10.7319 7.52729 10.4716L3.52729 6.47157C3.26694 6.21122 3.26694 5.78911 3.52729 5.52876Z",
    fill: "#529FBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDropdownIcon);
export default __webpack_public_path__ + "static/media/statusDropdownIcon.462a880dd652c0b189c2b126409f381e.svg";
export { ForwardRef as ReactComponent };